import { URITypeMap } from './enums/uri_type';
import { createURI, parseURIFromString } from './uri';
export function adURI(id) {
    return createURI(URITypeMap.AD, { id });
}
export function albumURI(id, disc) {
    return createURI(URITypeMap.ALBUM, {
        id,
        disc,
        hasBase62Id: true,
    });
}
export function applicationURI(id, args) {
    return createURI(URITypeMap.APPLICATION, {
        id: id,
        args: Array.isArray(args) ? args : [],
    });
}
export function artistURI(id) {
    return createURI(URITypeMap.ARTIST, {
        id,
        hasBase62Id: true,
    });
}
export function artistToplistURI(id, toplist) {
    return createURI(URITypeMap.ARTIST_TOPLIST, {
        id,
        toplist,
        hasBase62Id: true,
    });
}
export function artistConcertsURI(id) {
    return createURI(URITypeMap.ARTIST_CONCERTS, {
        id,
        hasBase62Id: true,
    });
}
export function audioURI(id) {
    return createURI(URITypeMap.AUDIO, {
        id,
        hasBase62Id: true,
    });
}
export function audioFileURI(extension, id) {
    return createURI(URITypeMap.AUDIO_FILE, {
        id,
        extension,
    });
}
export function collectionURI(username, category) {
    return createURI(URITypeMap.COLLECTION, {
        username,
        category,
    });
}
export function genreURI(genre) {
    return createURI(URITypeMap.GENRE, {
        genre,
    });
}
export function queueURI() {
    return createURI(URITypeMap.QUEUE, {});
}
export function cachedFilesURI() {
    return createURI(URITypeMap.CACHED_FILES, {});
}
export function canvasURI(id) {
    return createURI(URITypeMap.CANVAS, {
        id,
        hasBase62Id: true,
    });
}
export function chatMessageURI(id) {
    return createURI(URITypeMap.CHAT_MESSAGE, {
        id,
        hasBase62Id: true,
    });
}
export function collectionAlbumURI(username, id) {
    return createURI(URITypeMap.COLLECTION_ALBUM, {
        id,
        username,
        hasBase62Id: true,
    });
}
export function collectionArtistURI(username, id) {
    return createURI(URITypeMap.COLLECTION_ARTIST, {
        id,
        username,
        hasBase62Id: true,
    });
}
export function collectionMissingAlbumURI(username, id) {
    return createURI(URITypeMap.COLLECTION_MISSING_ALBUM, {
        id,
        username,
        hasBase62Id: true,
    });
}
export function collectionTrackListURI(username, id) {
    return createURI(URITypeMap.COLLECTION_TRACK_LIST, {
        id,
        username,
        hasBase62Id: true,
    });
}
export function commentURI(id) {
    return createURI(URITypeMap.COMMENT, {
        id,
        hasBase62Id: true,
    });
}
export function conceptURI(id) {
    return createURI(URITypeMap.CONCEPT, {
        id,
        hasBase62Id: true,
    });
}
export function concertURI(id) {
    return createURI(URITypeMap.CONCERT, {
        id,
        hasBase62Id: true,
    });
}
export function contextGroupURI(origin, name) {
    return createURI(URITypeMap.CONTEXT_GROUP, {
        origin,
        name,
        hasBase62Id: true,
    });
}
export function contributorURI(id) {
    return createURI(URITypeMap.CONTRIBUTOR, {
        id,
        hasBase62Id: true,
    });
}
export function culturalMomentURI(id) {
    return createURI(URITypeMap.CULTURAL_MOMENT, {
        id,
    });
}
export function dailyMixURI(id) {
    return createURI(URITypeMap.DAILY_MIX, {
        id,
        hasBase62Id: true,
    });
}
export function emptyURI() {
    return createURI(URITypeMap.EMPTY, {});
}
export function episodeURI(id, context, play) {
    return createURI(URITypeMap.EPISODE, {
        id,
        context: context ? parseURIFromString(context) : null,
        play,
        hasBase62Id: true,
    });
}
export function facebookURI(uid) {
    return createURI(URITypeMap.FACEBOOK, { uid: uid });
}
export function festivalURI(id) {
    return createURI(URITypeMap.FESTIVAL, {
        id,
        hasBase62Id: true,
    });
}
export function folderURI(username, id) {
    return createURI(URITypeMap.FOLDER, {
        id,
        username,
        hasBase62Id: true,
    });
}
export function followersURI(username) {
    return createURI(URITypeMap.FOLLOWERS, {
        username,
    });
}
export function followingURI(username) {
    return createURI(URITypeMap.FOLLOWING, {
        username,
    });
}
export function imageURI(id) {
    return createURI(URITypeMap.IMAGE, {
        id,
    });
}
export function inboxURI(username) {
    return createURI(URITypeMap.INBOX, { username });
}
export function interruptionURI(id) {
    return createURI(URITypeMap.INTERRUPTION, {
        id: id,
    });
}
export function jamURI(id, contextType, play) {
    return createURI(URITypeMap.JAM, {
        id,
        contextType,
        hasBase62Id: Boolean(id),
        play: Boolean(play),
    });
}
export function libraryURI(username, category) {
    return createURI(URITypeMap.LIBRARY, {
        username,
        category,
    });
}
export function liveURI(id) {
    return createURI(URITypeMap.LIVE, {
        id,
        hasBase62Id: true,
    });
}
export function roomURI(id) {
    return createURI(URITypeMap.ROOM, {
        id,
        hasBase62Id: true,
    });
}
export function expressionURI(id) {
    return createURI(URITypeMap.EXPRESSION, {
        id,
        hasBase62Id: true,
    });
}
export function questionURI(id) {
    return createURI(URITypeMap.QUESTION, {
        id,
        hasBase62Id: true,
    });
}
export function pollURI(id) {
    return createURI(URITypeMap.POLL, {
        id,
        hasBase62Id: true,
    });
}
export function responseURI(id) {
    return createURI(URITypeMap.RESPONSE, {
        id,
        hasBase62Id: true,
    });
}
export function localTrackURI(artist, album, track, duration) {
    return createURI(URITypeMap.LOCAL_TRACK, {
        artist,
        album,
        track,
        duration,
    });
}
/**
 * @deprecated Use `localTrackURI` instead.
 */
export const localURI = localTrackURI;
export function localAlbumURI(artist, album) {
    return createURI(URITypeMap.LOCAL_ALBUM, {
        artist: artist,
        album: album,
    });
}
export function localArtistURI(artist) {
    return createURI(URITypeMap.LOCAL_ARTIST, {
        artist: artist,
    });
}
export function merchURI(id) {
    return createURI(URITypeMap.MERCH, {
        id,
        hasBase62Id: true,
    });
}
export function merchHubURI() {
    return createURI(URITypeMap.MERCHHUB, {});
}
export function mosaicURI(ids) {
    return createURI(URITypeMap.MOSAIC, { ids: ids });
}
export function playlistURI(username, id) {
    return createURI(URITypeMap.PLAYLIST, {
        id,
        username,
        hasBase62Id: true,
    });
}
export function playlistV2URI(id) {
    return createURI(URITypeMap.PLAYLIST_V2, {
        id,
        hasBase62Id: true,
    });
}
export function prereleaseURI(id) {
    return createURI(URITypeMap.PRERELEASE, {
        id,
        hasBase62Id: true,
    });
}
export function profileURI(username, args) {
    return createURI(URITypeMap.PROFILE, {
        username,
        args: args !== null && args !== void 0 ? args : [],
    });
}
export function publishedRootlistURI(username) {
    return createURI(URITypeMap.PUBLISHED_ROOTLIST, {
        username,
    });
}
export function radioURI(args) {
    return createURI(URITypeMap.RADIO, {
        args: args !== null && args !== void 0 ? args : '',
    });
}
export function rootlistURI(username) {
    return createURI(URITypeMap.ROOTLIST, {
        username,
    });
}
export function searchURI(query) {
    return createURI(URITypeMap.SEARCH, { query: query });
}
export function showURI(id) {
    return createURI(URITypeMap.SHOW, { id, hasBase62Id: true });
}
export function socialSessionURI(id) {
    return createURI(URITypeMap.SOCIAL_SESSION, {
        id,
        hasBase62Id: true,
    });
}
export function specialURI(args) {
    return createURI(URITypeMap.SPECIAL, {
        args: args !== null && args !== void 0 ? args : [],
    });
}
export function starredURI(username) {
    return createURI(URITypeMap.STARRED, {
        username,
    });
}
export function stationURI(args) {
    return createURI(URITypeMap.STATION, {
        args: args !== null && args !== void 0 ? args : [],
    });
}
export function supplementaryMaterialURI(id) {
    return createURI(URITypeMap.SUPPLEMENTARY_MATERIAL, {
        id,
        hasBase62Id: true,
    });
}
export function temporaryPlaylistURI(origin, data) {
    return createURI(URITypeMap.TEMP_PLAYLIST, {
        origin: origin,
        data: data,
    });
}
export function toplistURI(toplist, country, global) {
    return createURI(URITypeMap.TOPLIST, {
        toplist,
        country,
        global: Boolean(global),
    });
}
export function tourURI(id) {
    return createURI(URITypeMap.TOUR, {
        id,
        hasBase62Id: true,
    });
}
export function trackURI(id, anchor, context, play) {
    return createURI(URITypeMap.TRACK, {
        id,
        anchor,
        context: context ? parseURIFromString(context) : null,
        play,
        hasBase62Id: true,
    });
}
export function tracksetURI(tracks, name, index) {
    return createURI(URITypeMap.TRACKSET, {
        tracks: tracks,
        name: name || '',
        index: isNaN(index) ? null : (index !== null && index !== void 0 ? index : null),
    });
}
export function userToplistURI(username, toplist) {
    return createURI(URITypeMap.USER_TOPLIST, {
        username,
        toplist,
    });
}
export function userTopTracksURI(username) {
    return createURI(URITypeMap.USER_TOP_TRACKS, {
        username,
    });
}
export function mediaURI(id) {
    return createURI(URITypeMap.MEDIA, {
        id,
        hasBase62Id: true,
    });
}
export function venueURI(id) {
    return createURI(URITypeMap.VENUE, {
        id,
        hasBase62Id: true,
    });
}
export function videoURI(id) {
    return createURI(URITypeMap.VIDEO, {
        id,
        hasBase62Id: true,
    });
}
export function courseURI(id) {
    return createURI(URITypeMap.COURSE, {
        id,
        hasBase62Id: true,
    });
}
export function lessonURI(id) {
    return createURI(URITypeMap.LESSON, {
        id,
        hasBase62Id: true,
    });
}
export function promoterURI(id) {
    return createURI(URITypeMap.PROMOTER, {
        id,
        hasBase62Id: true,
    });
}
export function promotionURI(id) {
    return createURI(URITypeMap.PROMOTION, {
        id,
        hasBase62Id: true,
    });
}
export function siteURI(id) {
    return createURI(URITypeMap.SITE, {
        id,
        hasBase62Id: true,
    });
}
export function presentsURI(id) {
    return createURI(URITypeMap.PRESENTS, {
        id,
        hasBase62Id: true,
    });
}
export function s4aThirdPartyURI(id) {
    return createURI(URITypeMap.S4A_THIRD_PARTY, {
        id,
        hasBase62Id: true,
    });
}
//# sourceMappingURL=factories.js.map